import { Component, ViewEncapsulation, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';

import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW5002Model } from './kymw5002.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';

import { NotNullTextInputComponent } from '../../kymw02/not-null-text-input/not-null-text-input.component';
import { KYMW5002SearchResultComponent } from './kymw5002-search-result/kymw5002-search-result.component';
import { KYMW5002ImageInfoDetailComponent } from './kymw5002-image-info-detail/kymw5002-image-info-detail.component';
import { KYMW5002UseImageComponent } from './kymw5002-use-image/kymw5002-use-image.component';
import { KYMW5002InputModel } from './vo/kymw5002-input.model';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW0B00Model } from '../../kymw0b/kymw0b00/kymw0b00.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { CheckboxLabelComponent } from '../../kymw02/checkbox-label/checkbox-label.component';
import { KYMW5002ImageInfoDetailBoxComponent } from './kymw5002-image-info-detail-box/kymw5002-image-info-detail-box.component';
import { KYMW0B00OutputModel } from '../../kymw0b/kymw0b00/vo/kymw0b00-output.model';
import { KYMW0B00Component } from '../../kymw0b/kymw0b00/kymw0b00.component';
import { KYMW50getImageInfoDetailService } from './api-services/kymw50-get-image-info-detail.service';
import { KYMW50getImageListService } from './api-services/kymw50-get-image-list.service';
import { KYMW50getSearchImageListService } from './api-services/kymw50-get-search-image-list.service';
import { KYMW50getUseRecordImageListService } from './api-services/kymw50-get-use-record-image-list.service';
import { KYMW50getUseRecordListService } from './api-services/kymw50-get-use-record-list.service';
import { Menu } from '@grapecity/wijmo.input';
import { KYMW50registImageDataService } from './api-services/kymw50-regist-image-data.service';

/**
 * EC使用画像指示画面を管理するクラス
 *
 * @export KYMW5002Component
 * @class KYMW5002Component
 */
@Component({
  selector: 'app-kymw5002',
  templateUrl: 'kymw5002.component.html',
  styleUrls: ['kymw5002.component.scss'],
  providers: [
    KYMW50getImageInfoDetailService,
    KYMW50getImageListService,
    KYMW50getSearchImageListService,
    KYMW50getUseRecordImageListService,
    KYMW50getUseRecordListService
  ],
  encapsulation: ViewEncapsulation.None
})
export class KYMW5002Component extends PlessViewHelperSub implements OnInit, AfterViewInit {
  kymw5002Model: KYMW5002Model = new KYMW5002Model();
  public kymw0B00Model: KYMW0B00Model = new KYMW0B00Model();
  public setKYMW5002Parameter: Function;

  // 子画面インスタンス化
  @ViewChild('txti_Caption', { static: true }) txti_Caption: NotNullTextInputComponent;
  @ViewChild('vw_SearchResult', { static: true }) vw_SearchResult: KYMW5002SearchResultComponent; // 検索結果
  @ViewChild('vw_ImageInfoDetail', { static: true }) vw_ImageInfoDetail: KYMW5002ImageInfoDetailComponent;
  @ViewChild('vw_UseImage', { static: true }) vw_UseImage: KYMW5002UseImageComponent;

  @ViewChild('btn_Setting', { static: true }) btn_Setting: ElementRef;

  @ViewChild('chk_AllCoop', { static: true }) chk_AllCoop: CheckboxLabelComponent;
  @ViewChild('chk_Ibaraki', { static: true }) chk_Ibaraki: CheckboxLabelComponent;
  @ViewChild('chk_Tochigi', { static: true }) chk_Tochigi: CheckboxLabelComponent;
  @ViewChild('chk_Gunma', { static: true }) chk_Gunma: CheckboxLabelComponent;
  @ViewChild('chk_Chiba', { static: true }) chk_Chiba: CheckboxLabelComponent;
  @ViewChild('chk_Saitama', { static: true }) chk_Saitama: CheckboxLabelComponent;
  @ViewChild('chk_Tokyo', { static: true }) chk_Tokyo: CheckboxLabelComponent;
  @ViewChild('chk_Nagano', { static: true }) chk_Nagano: CheckboxLabelComponent;
  @ViewChild('chk_Niigata', { static: true }) chk_Niigata: CheckboxLabelComponent;

  param = null;

  // コンテキストメニュー
  public useImageMenu: Menu = null;
  public goodsImageMenu: Menu = null;
  public useHistoryMenu: Menu = null;
  public searchImageMenu: Menu = null;
  kymw5002InputVO: any;

  /**
   *Creates an instance of KYMW5002Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW5002Component
   */
  constructor(
    public dialogServiceSub: PlessDialogServiceSub,
    public kymw50getImageInfoDetailService: KYMW50getImageInfoDetailService,
    public kymw50getImageListService: KYMW50getImageListService,
    public kymw50getSearchImageListService: KYMW50getSearchImageListService,
    public kymw50getUseRecordImageListService: KYMW50getUseRecordImageListService,
    public kymw50getUseRecordListService: KYMW50getUseRecordListService,
    public kymw50registImageDataService: KYMW50registImageDataService,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW5002';
    this.kymw5002Model.kymw5002Component = this;
    // コンテキストメニュー設定
    this.setContextMenu();

    // voから各値の設定
    this.procInputVO(this.kymw5002InputVO);

  }

  ngAfterViewInit() {

  }

  /**
   * コンテキストメニューを追加
   *
   * @memberof KYMW1404Component
   */
  setContextMenu(): void {
    // 使用画像
    this.useImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '指示解除', cmd: 'item1', disabled: true },
          { caption: '-' },
          { caption: '前へ', cmd: 'item2', disabled: true },
          { caption: '後ろへ', cmd: 'item3', disabled: true },
          { caption: '先頭へ', cmd: 'item4', disabled: true },
          { caption: '最後へ', cmd: 'item5', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.useImageMenu.selectedValue) {
            case 'item1':
              this.eventUseImageITEM1Change_MENU_SELECTHandler();
              break;
            case 'item2':
              this.eventUseImageITEM2Change_MENU_SELECTHandler();
              break;
            case 'item3':
              this.eventUseImageITEM3Change_MENU_SELECTHandler();
              break;
            case 'item4':
              this.eventUseImageITEM4Change_MENU_SELECTHandler();
              break;
            case 'item5':
              this.eventUseImageITEM5Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 商品画像
    this.goodsImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.goodsImageMenu.selectedValue) {
            case 'item1':
              this.eventGoodsImageITEM1Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 使用履歴
    this.useHistoryMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.useHistoryMenu.selectedValue) {
            case 'item1':
              this.eventUseHistoryITEM1Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 検索画像
    this.searchImageMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: '使用指示', cmd: 'item1', disabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: (s, e) => {
          switch (this.searchImageMenu.selectedValue) {
            case 'item1':
              this.eventSearchImageITEM1Change_MENU_SELECTHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理 (使用画像)
    this.vw_UseImage.hli_UseImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.useImageMenu !== undefined) {
        this.useImageMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (商品画像)
    this.vw_SearchResult.hli_GoodsImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.goodsImageMenu !== undefined) {
        this.goodsImageMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (使用履歴)
    this.vw_SearchResult.hli_UseHistoryImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.useHistoryMenu !== undefined) {
        this.useHistoryMenu.show(e);
      }
    });

    // 右クリック押下時 コンテキストメニュー表示処理 (検索結果)
    this.vw_SearchResult.hli_SearchImageList.nativeElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.searchImageMenu !== undefined) {
        this.searchImageMenu.show(e);
      }
    });

    // 活性制御用のリストに項目を追加
    // 使用画像
    this.initForcedEnabledForContextMenuItemByScreenMode('指示解除', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('前へ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('後ろへ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('先頭へ', 'true');
    this.initForcedEnabledForContextMenuItemByScreenMode('最後へ', 'true');

    // 商品画像
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');

    // 使用履歴
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');

    // 検索結果
    this.initForcedEnabledForContextMenuItemByScreenMode('使用指示', 'true');
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1400Component
   */
  public getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (item) => {
        if (this.getFuncPermission('KYMW5200') !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
          return false;
        }
        return !item.disabled;
      }
    };
  }

  /**
   * コンテキストメニュー指示解除ボタン押下イベント
   */
  public eventUseImageITEM1Change_MENU_SELECTHandler(): void {
    this.kymw5002Model.deleteSelectedUseImage();

    this.kymw5002Model.useImageList = this.kymw5002Model.useImageList;

    // ヘッダ部の画像キャプションをクリア
    this.setHeaderTextCaption(null);

    // コンテキストメニュー更新
    this.kymw5002Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー前へボタン押下イベント
   */
  public eventUseImageITEM2Change_MENU_SELECTHandler(): void {
    this.kymw5002Model.moveFrontSelectedUseImage();
  }

  /**
   * コンテキストメニュー後ろへボタン押下イベント
   */
  public eventUseImageITEM3Change_MENU_SELECTHandler(): void {
    this.kymw5002Model.moveNextSelectedUseImage();
  }

  /**
   * コンテキストメニュー先頭へボタン押下イベント
   */
  public eventUseImageITEM4Change_MENU_SELECTHandler(): void {
    this.kymw5002Model.moveFirstSelectedUseImage();
  }

  /**
   * コンテキストメニュー最後へへボタン押下イベント
   */
  public eventUseImageITEM5Change_MENU_SELECTHandler(): void {
    this.kymw5002Model.moveLastSelectedUseImage();
  }


  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   */
  public eventGoodsImageITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Ｐコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw5002Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    if (txtImageType === 'F') { // 「F：裏面」の場合
      this.dialogServiceSub.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // すでに使用画像に登録されていないかチェック
    if (this.kymw5002Model.isExistImageIdInUseImageList(this.kymw5002Model.selectedImageData.ImageId)) {
      this.dialogServiceSub.openAlertGetMessage('E0229');  // すでに使用中
      return;
    }

    this.kymw5002Model.moveSelectedGoodsImageToUseImage();

    // コンテキストメニュー更新
    this.kymw5002Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   */
  public eventUseHistoryITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Ｐコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw5002Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    if (txtImageType === 'F') { // 「F：裏面」の場合
      this.dialogServiceSub.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // チェック処理
    if (this.kymw5002Model.isExistImageIdInUseImageList(this.kymw5002Model.selectedImageData.ImageId)) {
      this.dialogServiceSub.openAlertGetMessage('E0229');
      return;
    }

    this.kymw5002Model.moveSelectedUseHistoryImageToUseImage();

    // コンテキストメニュー更新
    this.kymw5002Model.updateContextMenuEnabled();
  }

  /**
   * コンテキストメニュー使用指示ボタン押下イベント
   */
  public eventSearchImageITEM1Change_MENU_SELECTHandler(): void {
    // 画像名(Ｐコード + 画像種別)から画像種別を抽出
    const txtImageName: string = this.kymw5002Model.selectedImageData.ImageName;
    const txtImageType: string = txtImageName.substring(8, 9);

    // 画像種別のチェック
    if (txtImageType === 'F') { // 「F：裏面」の場合
      this.dialogServiceSub.openAlertGetMessage('E0207', ['選択された画像', '裏面画像', '使用指示']);
      return;
    }

    // チェック処理
    if (this.kymw5002Model.isExistImageIdInUseImageList(this.kymw5002Model.selectedImageData.ImageId)) {
      this.dialogServiceSub.openAlertGetMessage('E0229');
      return;
    }

    this.kymw5002Model.moveSelectedSearchImageToUseImage();

    // コンテキストメニュー更新
    this.kymw5002Model.updateContextMenuEnabled();
  }


  /**
   * パラメータ設定
   *
   * @memberof KYMW5002Component
   */
  public inputParameterSetting(): void {
    this.procInputVO(this.iInputVOArray);
  }

  /**
   * パラメータ設定
   *
   * @param {KYMW5002InputModel} inputVO
   * @memberof KYMW5002Component
   */
  public setInputVO(inputVO: KYMW5002InputModel): void {
    this.procInputVO(inputVO);
  }

  /**
   * インプットVO処理を行う
   */
  private procInputVO(inputVO: any): void {
    const vo: KYMW5002InputModel = inputVO;

    // インプットVOの内容をManageに格納する
    this.setKYMW5002InputVO(vo);

    // ヘッダ部の表示内容設定
    this.kymw5002Model.updateHeaderInfo();

    // 商品画像一覧を取得する
    this.dispatcherGetImageListEvent();

    // 会員生協チェックボックスの使用可否設定
    this.setEnableCoopCheckBox();

    // コンテキストメニューの活性化・非活性化処理
    this.kymw5002Model.updateContextMenuEnabled();

  }

  /**
   * KYMW5002InputVOの内容をマネージャーに設定する
   */
  private setKYMW5002InputVO(vo: KYMW5002InputModel): void {
    // 選択商品情報を格納
    this.kymw5002Model.inputFlg = vo.flg;
    this.kymw5002Model.inputOrderCode = vo.orderCode;
    this.kymw5002Model.inputPcode = vo.pcode;
    this.kymw5002Model.inputPushCoopCode = vo.pushCoopCode;
    this.kymw5002Model.inputGoodsName = vo.goodsName;
    this.kymw5002Model.inputGoodsStandardName = vo.goodsStandardName;

    // 呼び出し元フラグにより使用画像最大選択数を初期化
    if (vo.flg === '1') { // 「1:CWS商品マスタ画面」の場合
      this.kymw5002Model.maxUseImageCount = 1;
    } else { // 「2:商品企画メンテナンス画面」「3:商品画像情報」の場合
      this.kymw5002Model.maxUseImageCount = 99;
    }

    // 「使用履歴」タブのＰコードコンボの値設定
    this.kymw5002Model.pcodeList = [{ 'Pcode': [vo.pcode] }];

    // 呼び出し元画面から受け取った使用画像情報を
    // 「使用画像」一覧に表示する
    if (vo.useImageInfoVOList.length > 0									// 使用画像ありの場合
      && vo.useImageInfoVOList[0].ImageId !== '0') {
      this.kymw5002Model.useImageList = vo.useImageInfoVOList;
    } else { // 使用画像なしの場合
      this.kymw5002Model.useImageList = [];
    }

    this.kymw5002Model.inputEnableCoopCode = vo.enableCoopCodeVOList;
    this.kymw5002Model.inputSelectCoopCode = vo.selectCoopInfoVOList;
  }


  private setEnableCoopCheckBox(): void {
    // 呼び出し元フラグにより全生協チェックボックスの活性・非活性状態を初期化
    if (this.kymw5002Model.inputFlg === '1') { // 「1:CWS商品マスタ画面」の場合
      this.chk_AllCoop.disabled = true;
    } else { // 「2:商品企画メンテナンス画面」「3:商品画像情報」の場合
      this.chk_AllCoop.disabled = false;
    }

    // すべて非活性に設定
    this.chk_Ibaraki.disabled = true;
    this.chk_Tochigi.disabled = true;
    this.chk_Gunma.disabled = true;
    this.chk_Chiba.disabled = true;
    this.chk_Saitama.disabled = true;
    this.chk_Tokyo.disabled = true;
    this.chk_Nagano.disabled = true;
    this.chk_Niigata.disabled = true;

    // 各生協チェックボックスの活性・非活性状態を初期化
    for (let i = Number(0); i < this.kymw5002Model.inputEnableCoopCode.length; i++) {
      switch (this.kymw5002Model.inputEnableCoopCode[i].enableCoopCode) {
        case this.kymw00Model.COOP_CODE_IB:
          this.chk_Ibaraki.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_TO:
          this.chk_Tochigi.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_GU:
          this.chk_Gunma.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_TI:
          this.chk_Chiba.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_SA:
          this.chk_Saitama.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_TK:
          this.chk_Tokyo.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_NA:
          this.chk_Nagano.disabled = false;
          break;
        case this.kymw00Model.COOP_CODE_NI:
          this.chk_Niigata.disabled = false;
          break;
      }
    }

    // 各生協チェックボックスの選択状態を初期化
    for (let j = Number(0); j < this.kymw5002Model.inputSelectCoopCode.length; j++) {
      switch (this.kymw5002Model.inputSelectCoopCode[j].selectCoopCode) {
        case this.kymw00Model.COOP_CODE_IB:
          this.kymw5002Model.ibaraki = true;
          break;
        case this.kymw00Model.COOP_CODE_TO:
          this.kymw5002Model.tochigi = true;
          break;
        case this.kymw00Model.COOP_CODE_GU:
          this.kymw5002Model.gunma = true;
          break;
        case this.kymw00Model.COOP_CODE_TI:
          this.kymw5002Model.chiba = true;
          break;
        case this.kymw00Model.COOP_CODE_SA:
          this.kymw5002Model.saitama = true;
          break;
        case this.kymw00Model.COOP_CODE_TK:
          this.kymw5002Model.tokyo = true;
          break;
        case this.kymw00Model.COOP_CODE_NA:
          this.kymw5002Model.nagano = true;
          break;
        case this.kymw00Model.COOP_CODE_NI:
          this.kymw5002Model.niigata = true;
          break;
        case this.kymw00Model.COOP_CODE_KU:
          this.kymw5002Model.kuruco = true;
          break;
      }
    }

    this.eventChkCoop_CLICKHandler();
  }

  /**
   * 使用画像件数設定
   */
  public bindGoodsImageListLength_CHANGEHandler(goodsImageList: Array<any>): void {
    if (goodsImageList != null) {
      this.vw_SearchResult.useHitoryImageCnt = goodsImageList.length;
    }
  }

  /**
   * 使用画像件数設定
   */
  public bindUseHistoryImageListLength_CHANGEHandler(useHistoryImageList: Array<any>): void {
    if (useHistoryImageList != null) {
      this.vw_SearchResult.useHitoryImageCnt = useHistoryImageList.length;
    }
  }

  /**
   * 使用画像件数設定
   */
  public bindSearchImageListLength_CHANGEHandler(searchImageList: Array<any>): void {
    if (searchImageList != null) {
      this.vw_SearchResult.searchImageCnt = searchImageList.length;
    }
  }

  /**
   * 開始受注コードバインド
   */
  public bindStartOrderCodeTextInputSelectedOrderCode(orderCode: string): void {
    if (!PlessViewUtilsSub.isEmpty(orderCode) && this.imageInfoDetailBox.cmb_EndOrderCode2.nativeElement.selectedIndex === 2) {
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(orderCode);
    }
  }

  /**
   * 終了開始受注コードコンボボックスバインド
   */
  public bindEndOrderCodeComboBox(index: number): void {
    if (index === 0) {
      this.imageInfoDetailBox.txi_EndOrderCode1.disabled = false;
      this.imageInfoDetailBox.txi_EndOrderCode1.editable = true;
    } else if (index === 1) {
      this.imageInfoDetailBox.txi_EndOrderCode1.disabled = true;
      this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
    } else if (index === 2) {
      this.imageInfoDetailBox.txi_EndOrderCode1.disabled = false;
      this.imageInfoDetailBox.txi_EndOrderCode1.editable = false;

      if (!PlessViewUtilsSub.isEmpty(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode)) {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode(this.imageInfoDetailBox.txi_StartOrderCode.selectedOrderCode);
      } else {
        this.imageInfoDetailBox.txi_EndOrderCode1.setOrderCode('');
      }
    }
  }

  /**
   * 終了ボタンイベント
   */
  public eventBtnClose_CLICKHandler(event: Event): void {
    if (this.kymw5002Model.imageInfoDetailChangeFlg) {
      this.dialogServiceSub.openAlertGetMessage('Q0110', null,
        (closeDetail) => {
          this.eventBtnClose_CLICKHandlerClose(closeDetail);
        });
    } else {
      this.kymw0B00Model = new KYMW0B00Model();
      this.closeFunction();
    }
  }

  /**
   * 終了ボタンイベントアラートクローズイベント
   */
  private eventBtnClose_CLICKHandlerClose(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.kymw0B00Model = new KYMW0B00Model();
      this.closeFunction();
    }
  }

  /**
   * 【使用画像】画像クリック
   *
   * @param listEvent:ListEvent
   */
  public eventUseImageList_ITEMCLICKHandler(event: any): void {

    this.commonEventImageList_ITEMCLICKHandler(
      event.useImageList,
      event.index,
      (closeDetail) => {
        this.eventUseImageList_ITEMCLICKHandlerClose(closeDetail, event.useImageGroups);
      }, event.useImageGroups);
  }


  /**
   * 【使用画像】画像クリッククローズイベント
   */
  private eventUseImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups, this.kymw5002Model.getUseImageListSelectedImageIndex());
  }

  /**
   * 【検索結果】画像クリック
   *
   * @param listEvent:ListEvent
   */
  public eventGoodsImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.goodsImageList,
      event.index,
      (closeDetail) => {
        this.eventGoodsImageList_ITEMCLICKHandlerClose(closeDetail, event.goodsImageGroups);
      },
      event.goodsImageGroups);
  }

  /**
   * 【検索結果】画像クリッククローズイベント
   */
  private eventGoodsImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(
      closeDetail, imageGroups, this.kymw5002Model.getGoodsImageListSelectedImageIndex());
  }

  /**
   * 【履歴画像】画像クリック
   *
   * @param listEvent:ListEvent
   */
  public eventUseHistoryImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.useHistoryImageList,
      event.index,
      (closeDetail) => {
        this.eventUseHistoryImageList_ITEMCLICKHandlerClose(closeDetail, event.useHistoryImageGroups);
      },
      event.useHistoryImageGroups);
  }

  /**
   * 【検索結果】画像クリッククローズイベント
   */
  private eventUseHistoryImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups,
      this.kymw5002Model.getUseHistoryImageListSelectedImageIndex());
  }

  /**
   * 【検索結果】画像クリック
   *
   * @param listEvent:ListEvent
   */
  public eventSearchImageList_ITEMCLICKHandler(event: any): void {
    this.commonEventImageList_ITEMCLICKHandler(
      event.searchImageList,
      event.index,
      (closeDetail) => {
        this.eventSearchImageList_ITEMCLICKHandlerClose(closeDetail, event.searchImageGroups);
      },
      event.searchImageGroups);
  }

  /**
   * 【会員生協】全生協チェッククリック
   *
   */
  public eventChkAllCoop_CLICKHandler(): void {
    // 取扱生協のチェックボックスにのみ
    // 全生協チェックボックスの選択状態を反映させる
    if (!this.chk_Ibaraki.disabled) {
      this.kymw5002Model.ibaraki = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Tochigi.disabled) {
      this.kymw5002Model.tochigi = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Gunma.disabled) {
      this.kymw5002Model.gunma = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Chiba.disabled) {
      this.kymw5002Model.chiba = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Saitama.disabled) {
      this.kymw5002Model.saitama = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Tokyo.disabled) {
      this.kymw5002Model.tokyo = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Nagano.disabled) {
      this.kymw5002Model.nagano = this.kymw5002Model.allCoop;
    }
    if (!this.chk_Niigata.disabled) {
      this.kymw5002Model.niigata = this.kymw5002Model.allCoop;
    }
  }

  /**
   * 【会員生協】各生協チェッククリック
   * 
   */
  public eventChkCoop_CLICKHandler(): void {
    let coopCheckboxTarget: boolean[] = [
      this.kymw5002Model.ibaraki && !this.chk_Ibaraki.disabled,
      this.kymw5002Model.tochigi && !this.chk_Tochigi.disabled,
      this.kymw5002Model.gunma && !this.chk_Gunma.disabled,
      this.kymw5002Model.chiba && !this.chk_Chiba.disabled,
      this.kymw5002Model.saitama && !this.chk_Saitama.disabled,
      this.kymw5002Model.tokyo && !this.chk_Tokyo.disabled,
      this.kymw5002Model.nagano && !this.chk_Nagano.disabled,
      this.kymw5002Model.niigata && !this.chk_Niigata.disabled,
    ];
    coopCheckboxTarget = coopCheckboxTarget.filter(Boolean);

    this.kymw5002Model.allCoop = coopCheckboxTarget.length == this.kymw5002Model.inputEnableCoopCode.length;
  }

  /**
   * 【検索結果】画像クリッククローズイベント
   */
  private eventSearchImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement): void {
    this.commonEventImageList_ITEMCLICKHandlerClose(closeDetail, imageGroups, this.kymw5002Model.getSearchImageListSelectedImageIndex());
  }

  /**
   * イベント選択共通イベントHandler
   */
  public commonEventImageList_ITEMCLICKHandler(imageList: Array<any>, index: number,
    closeFunction: Function, imageGroups: HTMLElement): void {
    this.kymw5002Model.selectedImageExistFlg = index >= 0;
    if (index < 0) {
      this.kymw5002Model.updateContextMenuEnabled();

      // ヘッダ部の画像キャプションを設定
      this.setHeaderTextCaption(imageList, index);

      return;
    }

    // 同一イメージID調査
    if (this.kymw5002Model.selectedImageData != null
      && this.kymw5002Model.selectedImageData.ImageId === imageList[index].ImageId) {
      this.kymw5002Model.updateContextMenuEnabled();

      // ヘッダ部の画像キャプションを設定
      this.setHeaderTextCaption(imageList, index);

      // 画像の背景色設定
      this.setImageBackColor(imageGroups, index);

      return;
    }

    // 仮イメージID設定
    this.kymw5002Model.tempSelectedImageData = imageList[index];

    // 変更フラグチェック
    if (this.kymw5002Model.imageInfoDetailChangeFlg) {
      this.dialogServiceSub.openAlertGetMessage('Q0107', ['画像情報詳細'], closeFunction);
    } else {
      this.kymw5002Model.selectedImageData = this.kymw5002Model.tempSelectedImageData;

      this.dispatcherGetImageInfoDetailEvent();

      // ヘッダ部の画像キャプションを設定
      this.setHeaderTextCaption(imageList, index);

    }

    this.kymw5002Model.updateContextMenuEnabled();

    // 画像の背景色設定
    this.setImageBackColor(imageGroups, index);
  }


  /**
   * 画像の背景色を設定する
   *
   * @private
   * @param {HTMLElement} imageGroups
   * @param {number} index
   * @memberof KYMW5002Component
   */
  private setImageBackColor(imageGroups: HTMLElement, index: number) {
    // 全ての画像グループの背景色をもとに戻す
    for (let i = Number(0); i < this.vw_UseImage.useImageGroups.nativeElement.children.length; i++) {
      this.vw_UseImage.useImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.goodsImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.goodsImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.useHistoryImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.useHistoryImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    for (let i = Number(0); i < this.vw_SearchResult.searchImageGroups.nativeElement.children.length; i++) {
      this.vw_SearchResult.searchImageGroups.nativeElement.children[i].classList.remove('image-selected');
    }
    // 選択した画像の背景色を設定
    imageGroups.children[index].classList.add('image-selected');
  }

  /**
   * イベント選択共通イベントHandlerクローズ
   */
  private commonEventImageList_ITEMCLICKHandlerClose(closeDetail: number, imageGroups: HTMLElement,
    rollBackSelectedImageIndex: number): void {
    if (closeDetail === PlessAlert.Yes) {
      this.kymw5002Model.imageInfoDetailChangeFlg = false;
      this.kymw5002Model.selectedImageData = this.kymw5002Model.tempSelectedImageData;
      this.dispatcherGetImageInfoDetailEvent();

      // ヘッダ部の画像キャプションを設定
      this.setHeaderTextCaption(null);
    } else {
      this.setImageBackColor(imageGroups, rollBackSelectedImageIndex);
    }
  }

  /**
   * Ｐコードリスト変更イベント
   *
   */
  public eventPcodeList_CHANGEHandler(event: Event): void {
    // 使用履歴一覧を取得する
    this.dispatcherGetUseRecordListEvent();
  }

  /**
   * 【画像リスト】検索ボタン
   *
   * @param mouseEvent:MouseEvent
   */
  public eventBtnSearch_CLICKHandler(mouseEvent: MouseEvent): void {
    // 画像検索画面を呼び出す
    // 画像検索画面を呼び出す
    const componentRef = this.dialogServiceSub.openModal(KYMW0B00Component);
    const instance = componentRef.componentInstance as KYMW0B00Component;
    instance.kymw0B00Model = this.kymw0B00Model;
    instance.setKYMW0B00Parameter = (outputVO: KYMW0B00OutputModel) => {
      this.setKYMW0B00Parameter(outputVO);
    };
    instance.setInterfaceParam(this.kymw5002Model.getKYMW0B00InputVO());
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 【画像詳細】設定ボタン
   *
   * @param mouseEvent:MouseEvent
   */
  public eventSetting_CLICKHandler(mouseEvent: MouseEvent): void {
    // 呼び出し元画面が商品企画メンテナンス画面
    if (this.kymw5002Model.inputFlg === '2') {
      // 「会員生協」が未設定の場合、
      // 以下のメッセージを表示して処理を終了する。
      if (this.coopCheckedCount() === 0) {
        this.dialogServiceSub.openAlertGetMessage('W0001', ['会員生協']);
        return;
      }
      this.kymw5002Model.selectedCoopList = this.kymw5002Model.setCoopList();
      this.kymw50registImageDataService.execute(this.kymw5002Model, () => {
        this.refreshParentAndCloseChild();
      });
    } else {
      this.refreshParentAndCloseChild();
    }
  }

  /**
   * 親画面へ値を返却し、子画面を閉じる
   */
  public refreshParentAndCloseChild() {
    // アウトプットVOを返却する
    this.refreshParent();

    // 画面を終了する
    this.closeFunction();
  }

  /**
   * 使用履歴データグリッド選択イベント
   */
  public eventPcodeInfoList_CLICKHandler(event: Event): void {
    if (!this.kymw5002Model.flag && this.vw_SearchResult.dgv_PcodeInfoList.selection.row === 0) {
      this.kymw5002Model.flag = true;
    } else if (this.kymw5002Model.flag && this.vw_SearchResult.dgv_PcodeInfoList.selection.row > -1) {
      this.dispatcherGetUseRecordImageListEvent();
    }
  }

  /**
   * 画像キャプションテキストインプットの変更イベント
   */
  public eventTxtiCaption_CHANGEHandler(eventTargetValue: string): void {
    if (!PlessViewUtilsSub.isEmpty(this.kymw5002Model.textCaptionImageId)) {
      this.kymw5002Model.updateTextCaption(eventTargetValue);
    }
  }


  /*--------------------------------------------------------------------------------------------
  /* util area
  /*--------------------------------------------------------------------------------------------*/
  /**
   * ヘッダ部の画像キャプション表示
   */
  private setHeaderTextCaption(imageList: any, index: number = null): void {
    // 指示解除時、クリアする
    if (imageList == null) {
      this.plessEnabled(this.txti_Caption, false);
      this.txti_Caption.text = '';
      this.kymw5002Model.textCaptionImageId = '';
      return;
    }

    // ヘッダ部の画像キャプションを設定（使用画像かつ、商品企画メンテナンス画面または商品画像情報画面から呼び出された場合）
    if (this.vw_UseImage.useImageList[index] === imageList[index]
      && index != null && (this.kymw5002Model.inputFlg === '2' || this.kymw5002Model.inputFlg === '3')) {
      // 使用画像から呼びされかつ選択されていた場合
      this.plessEnabled(this.txti_Caption, true);
      this.kymw5002Model.textCaption = imageList[index].TextCaption;
      this.kymw5002Model.textCaptionImageId = imageList[index].ImageId;
    } else {
      this.plessEnabled(this.txti_Caption, false);
      this.kymw5002Model.textCaption = '';
      this.kymw5002Model.textCaptionImageId = '';
    }
  }


  /*------------------------------------------------------------------------------------------
  - Event Dispatch
  -----------------------------------*/
  /**
   * 画像情報イベント発行
   */
  public dispatcherGetImageListEvent(): void {
    const vo = this.kymw5002Model.getGetImageListVO();
    this.kymw50getImageListService.execute(this.kymw5002Model, vo);
  }

  /**
   * 画像詳細情報取得イベント発行
   */
  private dispatcherGetImageInfoDetailEvent(): void {
    const vo = this.kymw5002Model.getGetImageInfoDetailVO();
    this.kymw50getImageInfoDetailService.execute(this.kymw5002Model, vo);
  }

  /**
   * 使用履歴一覧取得イベント発行
   */
  private dispatcherGetUseRecordListEvent(): void {
    const vo = this.kymw5002Model.getGetUseRecordListVO();
    this.kymw50getUseRecordListService.execute(this.kymw5002Model, vo);
  }

  /**
   * 使用履歴画像リスト取得イベント発行
   */
  private dispatcherGetUseRecordImageListEvent(): void {
    const vo = this.kymw5002Model.getGetUseRecordImageListVO();
    this.kymw50getUseRecordImageListService.execute(this.kymw5002Model, vo);
  }

  /**
   * 検索画像リスト取得イベント発行
   */
  private dispatcherGetSearchImageListEvent(outputVO: KYMW0B00OutputModel): void {
    const vo = this.kymw5002Model.getGetSearchImageListVO(outputVO);
    this.kymw50getSearchImageListService.execute(this.kymw5002Model, vo);
  }

  private coopCheckedCount(): number {
    // 変数定義
    let i = Number(0);

    if (this.kymw5002Model.allCoop) {
      i++;
    }
    if (this.kymw5002Model.chiba) {
      i++;
    }
    if (this.kymw5002Model.gunma) {
      i++;
    }
    if (this.kymw5002Model.ibaraki) {
      i++;
    }
    if (this.kymw5002Model.nagano) {
      i++;
    }
    if (this.kymw5002Model.niigata) {
      i++;
    }
    if (this.kymw5002Model.saitama) {
      i++;
    }
    if (this.kymw5002Model.tochigi) {
      i++;
    }
    if (this.kymw5002Model.tokyo) {
      i++;
    }
    if (this.kymw5002Model.kuruco) {
      i++;
    }
    return i;
  }

  /**
   * 画像詳細情報VBOX取得
   */
  public get imageInfoDetailBox(): KYMW5002ImageInfoDetailBoxComponent {
    return this.vw_ImageInfoDetail.imageInfoDetailBox;
  }

  /*------------------------------------------------------------------------------------------
  - 子画面連携
  -----------------------------------*/
  /**
   * 検索条件を設定する
   *
   * @param KYMW0B00OutputVO
   */
  public setKYMW0B00Parameter(outputVO: KYMW0B00OutputModel): void {
    this.dispatcherGetSearchImageListEvent(outputVO);
  }

  /**
   * 親画面の再表示処理を行う。
   */
  public refreshParent(): void {
    // 親画面に返却する
    this.setKYMW5002Parameter(this.kymw5002Model.getKymw5002OutputVO());
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW5002Component
   */
  public setInterfaceParam(param: any): void {
    // 親画面のinputVOをそのまま受け取る
    this.kymw5002InputVO = param;
  }
}
